
import { defineComponent, ref } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code2 } from "./data";

export default defineComponent({
  name: "disabled",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      input: ref(""),
      code2
    };
  }
});
